// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0896136a","977":"b118050d"}[chunkId] + ".chunk.js";
};